// extracted by mini-css-extract-plugin
export default {"inputWrap":"consultationFormUserMain_inputWrap__mrIdR","userInfo":"consultationFormUserMain_userInfo__87tQo","groupItem":"consultationFormUserMain_groupItem__bDlak"};